import type {UseQueryOptions, UseQueryResult} from '@tanstack/react-query'
import {useAsync} from '@freckle/educator-entities/ts/common/hooks/use-async'
import type {BaseTeacherAttrs} from '@freckle/educator-entities/ts/users/models/teacher'
import {fetchTeachersAsASchoolAdmin} from '@freckle/educator-entities/ts/users/models/teacher'

export function useTeachersAsASchoolAdmin(
  options?: Partial<UseQueryOptions<BaseTeacherAttrs[]>>
): UseQueryResult<BaseTeacherAttrs[]> {
  const defaultOptions = {staleTime: 60 * 1000}
  return useAsync(fetchTeachersAsASchoolAdmin, 'fetchTeachersAsASchoolAdmin', [], {
    ...defaultOptions,
    ...options
  })
}
